import { createSlice } from "@reduxjs/toolkit";
const initialCutOffDateState =  {cutOffDateData: {}} ;

export const cutOffDateSlice = createSlice({
  name: "cutOffDate",
  initialState: initialCutOffDateState,
  reducers: {
    setCutOffDateState(state, action) {
      state.cutOffDateData = { ...state.cutOffDateData, ...action.payload };
    },
    resetCutOffDateState(state) {
     // state.personData = {};
     return initialCutOffDateState;
    }
  },
});
